import React from 'react'
import { View, ActivityIndicator, StyleSheet } from 'react-native'

const AppLoading = () => (
  <View style={styles.loading}>
    <ActivityIndicator size={80} color="#fff" />
  </View>
)

const styles = StyleSheet.create({
  loading: {
    width: '100vw',
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
  },
})

export default AppLoading
